import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonComponentsModule } from '@app/modules/common/common.module';

const routes: Routes = [
  {
    path: 'compte',
    loadChildren: '@app/modules/authentification/authentification.module#AuthentificationModule'
  },
  {
    path: 'confirmation-payement',
    loadChildren: '@app/modules/confirmation-payement/confirmation-payement.module#ConfirmationPayementModule'
  },
  {
    path: '',
    loadChildren: '@app/modules/views/views.module#ViewsModule'
  },
  {
    path:'**',
    redirectTo:'',
    pathMatch:'full'
  }
];

@NgModule({
  imports: [
    CommonComponentsModule,
    RouterModule.forRoot(routes),
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
